<template>
  <div v-if="currentUser.rights.settings" class="w-100">
    <div class="col-12 content-wrapper-transparent" style="padding:0;">
      <h2 class="m-0 mb-3">Настройки</h2>
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <span v-if="currentUser.rights.viewSettingsMain" :class="['nav-link', {'active': currentTab == 'main'}]" @click="currentTab = 'main'">Основные</span>
        </li>
        <li class="nav-item">
          <span v-if="currentUser.rights.viewSettingsSip" :class="['nav-link', {'active': currentTab == 'phone'}]" @click="currentTab = 'phone'">Телфония</span>
        </li>
        <li class="nav-item">
          <span v-if="currentUser.rights.viewSettingsRoles" :class="['nav-link', {'active': currentTab == 'roles'}]" @click="currentTab = 'roles'">Роли</span>
        </li>
      </ul>
    </div>
    <div class="col-12 content-wrapper">
      <!-- Основные -->
      <div v-if="currentUser.rights.viewSettingsMain" v-show="currentTab == 'main'">
        <h2 class="m-0 mb-3">Основные настройки</h2>
        <div v-if="currentUser.rights.editSettingsMain"  class="mb-3">
          <button v-on:click="saveUser" class="btn btn-success" type="button">Сохранить настройки пользователя</button>&nbsp;
          <button v-on:click="resetUser" class="btn btn-danger" type="button">Отменить изменения</button>
        </div>
        <div v-else class="alert alert-info">У Вас нет прав на изменения информации в этом разделе</div>
        <div class="col-12 col-lg-6">
          <div class="form-group col-12">
            <label>Имя</label>
            <input v-if="currentUser.rights.editSettingsMain" type="text" class="form-control" v-model="userForm.name">
            <h5 v-else>{{ userForm.name }}</h5>
          </div>
          <div class="form-group col-12">
            <label>Email</label>
            <input v-if="currentUser.rights.editSettingsMain" type="email" class="form-control" v-model="userForm.email">
            <h5 v-else>{{ userForm.email }}</h5>
          </div>
          <div class="form-row col-12">
            <label>Телефон</label>
            <input v-if="currentUser.rights.editSettingsMain" type="tel" class="form-control" v-model="userForm.phone">
            <h5 v-else>{{ userForm.phone }}</h5>
          </div>
          <div v-if="currentUser.rights.editSettingsMain" class="form-group d-flex justify-content-between col-12 flex-wrap mb-5">
            <label class="col-12 p-0">Изменить пароль</label>
            <input type="text" class="form-control col-6"  v-model="userForm.password">
            <span class="btn btn-info col-3" v-on:click="generateUserPassword">Сгенерировать пароль</span>
          </div>
        </div>
      </div>
      <!-- Телефония -->
      <div v-if="currentUser.rights.viewSettingsSip" v-show="currentTab == 'phone'">
        <h2 class="m-0 mb-3">Настройки телефонии</h2>
        <div v-if="currentUser.rights.editSettingsSip" class="mb-3">
          <button v-on:click="saveSip" class="btn btn-success" type="button">Сохранить настройки телефонии</button>&nbsp;
          <button v-on:click="resetSip" class="btn btn-danger" type="button">Отменить изменения</button>
        </div>
        <div v-else class="alert alert-info">У Вас нет прав на изменения информации в этом разделе</div>
        <div class="form-row">
          <div class="form-group col-6">
            <label>Адрес сервера</label>
            <input v-if="currentUser.rights.editSettingsSip" type="text" class="form-control" v-model="sipForm.sip_server">
            <h5 v-else>{{ sipForm.sip_server }}</h5>
          </div>
          <div class="form-group col-6">
            <label>Порт</label>
            <input v-if="currentUser.rights.editSettingsSip" type="text" class="form-control" v-model="sipForm.sip_port">
            <h5 v-else>{{ sipForm.sip_port }}</h5>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-6">
            <label>SIP пользователь</label>
            <input v-if="currentUser.rights.editSettingsSip" type="text" class="form-control" v-model="sipForm.sip_user">
            <h5 v-else>{{ sipForm.sip_user }}</h5>
          </div>
          <div class="form-group col-6">
            <label>Пароль</label>
            <input v-if="currentUser.rights.editSettingsSip" type="text" class="form-control" v-model="sipForm.sip_password">
            <h5 v-else>{{ sipForm.sip_password }}</h5>
          </div>
        </div>
        <div v-if="currentUser.rights.editSettingsSip" class="mb-3">
          <button v-on:click="generateSip" class="btn btn-success" type="button">Сгенерировать настройки телефонии</button>
        </div>
      </div>
      <!-- Роли -->
      <div v-if="currentUser.rights.viewSettingsRoles" v-show="currentTab == 'roles'">
        <h2 class="m-0 mb-3">Настройки ролей</h2>
        <div v-if="currentUser.rights.editSettingsRoles" class="mb-3">
          <button v-on:click="saveRoles" class="btn btn-success" type="button">Сохранить роли</button>&nbsp;
          <button v-on:click="resetRoles" class="btn btn-danger" type="button">Отменить изменения</button>
        </div>
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Действие/Роль</th>
              <th class="text-center" v-for="(role, index) in filtredRoles" :key="index">
                <input v-if="currentUser.rights.editSettingsRoles" type="text" v-model="role.name">
                <span v-else>{{ role.name }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, key) in rolesStruct" :key="key">
              <td>{{item.title}}</td>
              <td class="text-center" v-for="(role, index) in filtredRoles" :key="index">
                <input v-if="currentUser.rights.editSettingsRoles" type="checkbox" v-model="role.rights[key]" class="form-check-input">
                <span v-else>{{ role.rights[key] ? 'Да': 'Нет' }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="currentUser.rights.editSettingsRoles" class="d-flex justify-content-end pt-3 border-top border-white">
          <button v-on:click="addRole" class="btn btn-info" type="button">Добавить роль</button>
        </div>
      </div>
    </div>
  </div>
  <!-- root div end -->
  <div v-else class="alert alert-info">У Вас нет прав на доступ в этот раздел</div>
</template>

<script>
export default {
  data () {
    return {
      currentTab: 'main',
      userForm: {
        id: 0,
        name: '',
        email: '',
        phone: '',
        reg_date: '',
        password: '',
        client_id: 0,
        role_id: 0
      },
      sipForm: {
        id: 0,
        user_id: 0,
        internal_client: 0,
        sip_server: 'mz.sip.dela.bz',
        sip_port: '5090',
        sip_user: '',
        sip_password: ''
      },
      roles: [],
      rolesStruct: {},
      defaultRole: {name: 'Новая роль', client_id: 0, parent_id: 0, id: 0, rights: {}}
    }
  },
  computed: {
    systemSettings: function () {
      return this.$store.getters.system_settings
    },
    currentUser: {
      get: function () {
        return this.$store.getters.user
      },
      set: function (newValue) {
        this.$store.commit('setUser', newValue)
      }
    },
    sipSettings: {
      get: function () {
        return this.$store.getters.sip_settings
      },
      set: function (newValue) {
        this.$store.commit('setSIP', newValue)
      }
    },
    clientId: function () {
      return this.$store.getters.client_id
    },
    filtredRoles: function () {
      let roles = this.roles
      let newArr = []
      roles.forEach(function (role) {
        if (!(roles.some(elem => elem.parent_id === role.id)) || role.parent_id > 0 || role.id == 0) {
          newArr.push(role)
        }
      })
      return newArr
    }
  },
  methods: {
    saveUser: function () {
      let sendData = JSON.parse(JSON.stringify(this.userForm))
      sendData.action = 'saveUser'
      this.axios.post(this.systemSettings.api_host + '/ajax.php', sendData)
        .then(response => {
          this.updateCurrentUser()
        })
    },
    resetUser: function () {
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getUser&id=' + this.currentUser.id)
        .then(response => {
          this.userForm = response.data.user
          this.userForm.password = ''
        })
    },
    generateUserPassword: function () {
      let password = ''
      let symbols = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let length = 8
      for (let i = 0; i < length; i++) {
        password += symbols.charAt(Math.floor(Math.random() * symbols.length))
      }
      this.userForm.password = password
    },
    saveSip: function () {
      let sendData = {
        action: 'saveSipSettings',
        id: this.sipForm.id,
        user_id: this.sipForm.user_id,
        sip_server: this.sipForm.sip_server,
        sip_port: this.sipForm.sip_port,
        sip_user: this.sipForm.sip_user,
        sip_password: this.sipForm.sip_password,
        internal_client: this.sipForm.internal_client
      }
      // console.dir(sendData)
      this.axios.post(this.systemSettings.api_host + '/ajax.php', sendData)
        .then(response => {
          this.updateCurrentUser()
        })
    },
    generateSip: function () {
      var sipData = {}
      sipData.action = 'generateSipSettings'
      sipData.user_id = this.sipForm.user_id
      this.axios.post(this.systemSettings.api_host + '/ajax.php', sipData)
        .then(response => {
          this.updateCurrentUser()
        })
    },
    resetSip: function () {
      this.sipForm = JSON.parse(JSON.stringify(this.sipSettings))
    },
    addRole: function () {
      let newRole = JSON.parse(JSON.stringify(this.defaultRole))
      this.roles.push(newRole)
    },
    deleteRole: function (roleID) {
      let commonRole = this.roles.find(role => role.id === roleID)
      if (roleID > 3) {
        commonRole.action = 'deleteRole'
        this.axios.post(this.systemSettings.api_host + '/ajax.php', commonRole)
        let index = this.roles.indexOf(commonRole)
        this.roles.splice(index, 1)
      }
      this.updateCurrentUser()
    },
    saveRoles: function () {
      let saveData = {
        action: 'saveRoles',
        client_id: this.clientId,
        roles: this.roles
      }
      this.axios.post(this.systemSettings.api_host + '/ajax.php', saveData)
        .then(response => {
          this.roles = response.data.roles
          this.rolesStruct = response.data.rolesStruct
        })
      // this.updateCurrentUser()
    },
    resetRoles: function () {
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getRolesList&client_id=' + this.clientId)
        .then(response => {
          this.roles = response.data.roles
          this.rolesStruct = response.data.rolesStruct
        })
    },
    updateCurrentUser: function () {
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=auth')
        .then(response => {
          if (response.data.user.id < 1) {
            window.location.href = this.systemSettings.api_host + '/login.php'
            console.log(response.data)
          }
          this.currentUser = response.data.user
          this.rolesList = response.data.roles
          this.sipSettings = response.data.sip_settings
          console.log(this.currentUser)
          this.dataReady = true
          this.resetSip()
        })
    }
  },
  mounted () {
    this.resetUser()
    this.resetSip()
    this.resetRoles()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings.vue